import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Florigen error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui', background: '#0A0E1A', color: '#E2E8F0', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <h2>Something went wrong</h2>
          <p style={{ color: '#94A3B8', marginTop: 8 }}>Please refresh the page. If the problem persists, contact support.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.6rem 2rem', fontSize: '1rem', cursor: 'pointer',
              borderRadius: '8px', border: '1px solid rgba(124,58,237,0.4)',
              background: 'rgba(124,58,237,0.15)', color: '#A78BFA', marginTop: 16,
              fontWeight: 600
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
